import { jsx as o } from "react/jsx-runtime";
import { c as e } from "./index-65016bfa.mjs";
import { styled as a, css as c } from "styled-components";
import "@fcamna/shared-component-foundations";
import "react";
import { u as l } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { ButtonV1 as d } from "./buttonV1.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./Aria-f5e019e2.mjs";
import "./combineRefs-90f27925.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
const B = a.div`
  &.ButtonGroup {
    ${({
  theme: {
    components: { buttonGroup: t }
  }
}) => c(t.Container)};
  }
`, Q = ({ size: t = "medium", buttonData: r, style: m, className: p }) => {
  const i = l({ label: "Button Group" });
  return /* @__PURE__ */ o(
    B,
    {
      className: e(["ButtonGroup", p]),
      style: m,
      ...i,
      children: r.map(({ label: u, ...n }, s) => /* @__PURE__ */ o(
        d,
        {
          size: t,
          ...n,
          children: u
        },
        `button-${s}`
      ))
    }
  );
};
export {
  Q as ButtonGroup
};
